import i18n from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import {initReactI18next} from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import languageEN from './locale/en/translate.json'
import languageET from './locale/et/translate.json'
import languageRU from './locale/ru/translate.json'

i18n
    .use(XHR)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: languageEN,
            et: languageET,
            ru: languageRU
        },
        /* default language when load the website in browser if is commented in, uses this language every time page is refreshed */
        lng: "en",
        /* When react i18next not finding any language to as default in browser */
        fallbackLng: "en",
        whitelist: ['en', 'et','ru'],
        /* debugger For Development environment */
        debug: true,
        ns: ["translations"],
        defaultNS: "translations",
        keySeparator: ".",
        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        },
        react: {
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default',
            useSuspense: false
        }
    })

export default i18n;
